import React from 'react';
import logo from "../../common/media/cc_logo_white.svg";
import AASFLogo from "../media/aa-smartfuel-logo.svg";
import logo_merchant from "../media/AA-Logo.svg"; // use here or from cloudinary

const Header = () => {
    return (
        <>
            <div className="h-100vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                    <div className="container d-flex pt-2 pb-2">
                        <div className="right py-2">
                            <a target="_blank" className="btn btn-primary btn-lg" href={`${process.env.MY_CC_URL}/`}>Login to My CarbonClick</a>
                        </div>
                    </div>
                <div className="container color-white text-left">
                    <div className="mobile-hide">
                        <div className="mw-720px">
                            <img className="mb-3" src={logo_merchant} style={{ height: '80px' }} />
                            <h1 className="mb-4 text-shadow mt-0">Becoming a climate friendly traveller has never been simpler</h1>
                            <h3 className="mb-3 text-shadow">We've partnered with CarbonClick to help you reduce your environmental impact and become Climate Friendly. You can even offset your emissions through your AA Smartfuel Rewards.</h3>
                            <div className="d-flex mobile-hide mb-4 ">
                                <a className="btn btn-secondary btn-lg font-bold mr-2 d-flex align-center" target="_blank" href={`https://aasf.carbon.click/#HowItWorks`}>
                                    <img className="mr-2" src={AASFLogo} />
                                    <span>
                                        Offset with Rewards
                                    </span>
                                </a>
                                <a className="d-flex btn btn-primary btn-lg align-center" href="#DrivingCalculator">
                                    Offset My Driving
                                </a>
                            </div>
                        </div>

                        <div className="d-flex align-center">
                            <p className="mr-2 mb-0 mt-1 font-bold">Powered By</p>
                            <div>
                                <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <img className="mb-3" src={logo_merchant} style={{ height: '50px' }} />
                        <h2 className="mb-4 text-shadow mt-0">Travelling climate friendly has never been easier</h2>
                        <a className="btn btn-secondary btn-lg font-bold my-2 mr-2" target="_blank" href={`${process.env.MY_CC_URL}/my-cc?aasmartfuel`}> Join the movement</a>
                        <a className="btn btn-primary btn-lg font-bold" href="#DrivingCalculator">Offset My Driving</a>
                    </div>
                </div>

                <div className="position-absolute bottom-abs w-100 pb-2 h-80px">
                    <a href="#content"><div className="arrow arrow-first"></div></a>
                </div>
        </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <h5 className="mr-2 font-bold mt-1 mb-0">Powered By</h5>
                        <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 24 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;